import { FC, PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';
import classes from './Modal.module.scss';
import { IconButton } from 'components/buttons';
import { Close } from 'components/icons/Close';
import colors from 'styles/modules/colors.module.scss';

type ModalProps = FC<
    PropsWithChildren<{
        hasHeader?: boolean;
        customClasses?: string;
        handleClose: (...data: any) => any;
        isOpen: boolean;
        title?: string;
        icon?: any;
    }>
>;

const Modal: ModalProps = ({ icon, children, isOpen, handleClose, title, customClasses, hasHeader = true }) => {
    if (!isOpen) return <></>;

    return createPortal(
        <div className={classes.backdrop}>
            <div className={hasHeader ? classes.modal : classes.notifyModal}>
                {hasHeader ? (
                    <div className={icon ? classes.iconHeader : classes.header}>
                        <div className={classes.iconTitle}>
                            {icon && <div className={classes.icon}>{icon}</div>}
                            <h5>{title}</h5>
                        </div>
                        <IconButton onClick={handleClose} className="light" icon={<Close fill={colors.grayDark} />} />
                    </div>
                ) : (
                    <></>
                )}
                <div className={`${classes.scrollable} ${customClasses}`}>{children}</div>
            </div>
        </div>,
        document.getElementById('modal-root') as Element
    );
};

export default Modal;
